import SenpiperBG from "../assets/SenpiperBG.svg";
import icon from "../assets/Icons.svg";
import ContactModal from "./ContactModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false); // ✅ modal state
  const navigate = useNavigate();


  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest("nav")) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleTermsClick = () => {
    navigate("/terms-of-service");
  };

  // Handler for Privacy Policy
  const handlePrivacyClick = () => {
    navigate("/privacy-policy");
  };

  return (
    <>
      <footer className="w-full bg-blue-900 px-4 sm:px-6 md:px-10 lg:px-20 py-8 sm:py-10 flex flex-col gap-6 sm:gap-8">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 sm:gap-8">
          {/* Left Side */}
          <div className="flex flex-col items-center md:items-start gap-4 sm:gap-6 flex-1">
            {/* Logo */}
            <img
              src={SenpiperBG}
              alt="Senpiper"
              className="h-8 sm:h-10 md:h-12 w-auto"
            />

            {/* Email Info */}
            <a
              href="mailto:info@senpiper.com"
              className="flex items-center gap-2 sm:gap-3 hover:underline transition-colors"
            >
              <div className="w-5 h-5 sm:w-6 sm:h-6 relative">
                <img src={icon} alt="Email Icon" className="w-full h-full" />
              </div>
              <span className="text-slate-50 text-sm sm:text-base md:text-lg lg:text-xl font-normal font-['Nunito Sans']">
                info@senpiper.com
              </span>
            </a>
          </div>

          {/* Right Side Links */}
          <div className="flex flex-col items-end md:items-end gap-4 sm:gap-6 flex-1">
            {/* Top Row - Contact Us & Request Demo */}
            <div className="flex flex-row gap-4 sm:gap-6 md:gap-10 lg:gap-16">
              
              <button
                onClick={() => setIsContactOpen(true)}
                className="text-slate-50 text-sm sm:text-base md:text-lg lg:text-xl font-normal font-['Nunito Sans'] hover:underline transition-colors whitespace-nowrap"
              >
                Request Demo
              </button>
              <button
                onClick={handleTermsClick}
                className="text-slate-50 text-sm sm:text-base md:text-lg lg:text-xl font-normal font-['Nunito Sans'] hover:underline transition-colors whitespace-nowrap"
              >
                Terms of Service
              </button>
              
            </div>

            {/* Bottom Row - Terms & Privacy */}
            <div className="flex flex-row gap-4 sm:gap-6 md:gap-10 lg:gap-16">
              <button
                onClick={() => setIsContactOpen(true)}
                className="text-slate-50 text-sm sm:text-base md:text-lg lg:text-xl font-normal font-['Nunito Sans'] hover:underline transition-colors whitespace-nowrap"
              >
                Contact Us
              </button>
              <button
                onClick={handlePrivacyClick}
                className="text-slate-50 text-sm sm:text-base md:text-lg lg:text-xl font-normal font-['Nunito Sans'] hover:underline transition-colors whitespace-nowrap"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright */}
        <div className="w-full text-slate-50 text-xs sm:text-sm md:text-base font-normal font-['Nunito Sans'] text-center md:text-left">
          © 2025 Senpiper. All rights reserved.
        </div>
      </footer>

      {/* Contact Modal with required props */}
      <ContactModal
        open={isContactOpen}
        onClose={() => setIsContactOpen(false)}
        onSave={(contact) => {
          console.log("Contact saved:", contact);
          // setIsContactOpen(false);
        }}
      />
    </>
  );
};

export default Footer;